import { call, put, select } from 'redux-saga/effects';
import API from '../services/api';
import types from '../redux/types';
import { getPreviewPortalId, stopPortalPreview } from '../redux/portal/actions';
import { setAlert } from '../redux/dashboard/actions';
import utils from '../utils';

export function* fetchPortals() {
  const previewPortalId = yield select(getPreviewPortalId);

  try {
    yield put({ type: types.LOAD_PORTALS, payload: null });
    if (!previewPortalId) yield put({ type: types.SELECT_PORTAL, payload: null });

    const portals = yield call(API.getPortals);
    const brandPortals = portals?.brandPortals || [];
    yield put({ type: types.LOAD_PORTALS, payload: brandPortals });
    if (previewPortalId) {
      const previewPortal = brandPortals.find(portal => portal.id === previewPortalId);
      if (previewPortal) {
        yield put({ type: types.SELECT_PORTAL, payload: previewPortal });
      } else {
        yield put(stopPortalPreview());
        yield put(setAlert(utils.generateAlert('Portal preview is no longer available.', 'error')));
      }
    } else {
      yield put({ type: types.SELECT_PORTAL, payload: brandPortals[0] || null });
    }
  } catch (error) {
    yield put({ type: types.LOAD_PORTALS, payload: [] });
    if (previewPortalId) {
      yield put(stopPortalPreview());
      yield put(setAlert(utils.generateAlert('Portal preview could not be loaded.', 'error')));
    } else {
      yield put({ type: types.SELECT_PORTAL, payload: null });
    }
    console.error("Couldn't fetch portals", error);
  }
}
